import {ChangeDetectionStrategy, Component, HostListener, OnInit} from '@angular/core';
import {PrimeNG} from 'primeng/config';
import {ActivatedRoute, RouterModule} from "@angular/router";
import {ToastModule} from "primeng/toast";
import {Store} from "@ngrx/store";
import {isWarehosueOrderId, setDeliverTokenId,setDeliveryAcknowledgeViewStatus,isOrderInParamsAction,setOrderIdForTimeline,setDocketId} from "./state/home/home.action";
import {AppState} from "src/app/state/app.state";
import {PwaUpdateService} from "src/app/service/pwa.update.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterModule, ToastModule]
})
export class AppComponent implements OnInit{
  constructor(
    private primengConfig: PrimeNG,
    private store: Store<AppState>,
    private activatedRoute: ActivatedRoute,
    private update: PwaUpdateService
  ) {
    // PwaUpdateService wires up update handling in its own constructor - injecting it is enough.
  }

  ngOnInit() {
    this.primengConfig.ripple.set(true);
    this.activatedRoute.queryParams.subscribe((params) => {
      const token = params['deliveryTokenId'];
      const isOrderId = params['orderId']
      const orderIdForTimeline = params['orderIdForTimeline']
      const docketId = params['docketId']
      if(token){
        this.store.dispatch(setDeliverTokenId({data: token}));
      }
      if(isOrderId){
        this.store.dispatch(isOrderInParamsAction({value:isOrderId}))
      }
      if(orderIdForTimeline){
        this.store.dispatch(setOrderIdForTimeline({value:orderIdForTimeline}))
      }
      if(docketId){
        this.store.dispatch(setDocketId({value:docketId}))
      }
      const acknowledgeDeliveryStatus = params['acknowledgeDelivery'];
      acknowledgeDeliveryStatus && 
      this.store.dispatch(setDeliveryAcknowledgeViewStatus({status: acknowledgeDeliveryStatus}));
      const isWarehouseOrderId = params['warehouseOrderId'];
      isWarehouseOrderId && this.store.dispatch(isWarehosueOrderId({orderId:'12345'}))
    })
  }

  title = 'iotzen-ui-customer-order-track';
  @HostListener('document:touchstart', ['$event'])
  onFirstTouch(): void {
    document.removeEventListener('touchstart', this.onFirstTouch as EventListener);
    const el = document.documentElement;
    if (!el.requestFullscreen || document.fullscreenElement) return;

    const isStandalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.matchMedia('(display-mode: fullscreen)').matches ||
      (navigator as any).standalone === true;
    if (isStandalone) return;

    el.requestFullscreen({ navigationUI: 'hide' }).catch(() => {});
  }
}
